import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    CmpsCardComponentModule,
    CmpsCardHeaderRowComponentModule,
    CmpsInsightCoachingPerformanceModule,
    CmpsMetricPerformanceModule,
} from '@cmps/ng-kit';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsPortalModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsMyCoachingCardModule } from '../card--my-coaching-card/my-coaching-card.module';
import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsInsightExplorerModule } from '../insight-explorer/insight-explorer.module';
import { epicObs } from '../store';
import { CmpsQuickAccessModule } from '../user/quick-access/quick-access.module';

import { MyPerformanceCardComponent } from './my-performance-card.component';
import { performanceCardEpics } from './my-performance-card.epic';
import { TranslationIdMap } from './my-performance-card.i18n';
import { MyPerformanceCardService } from './my-performance-card.service';
import { CmpsPillarViewDialogComponent } from './pillar-view-dialog/pillar-view-dialog.component';
import { metricPerformanceDataEpics } from './state/metric-performance-data.epic';
import { myPerformanceCardEpics } from './state/performance-data.epic';

@NgModule({
    imports: [
        CommonModule,
        CmpsCommonModule,
        CmpsCardComponentModule,
        CmpsCardHeaderRowComponentModule,
        CmpsDialogModule,
        CmpsMetricPerformanceModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsInsightCoachingPerformanceModule,
        CmpsIconModule,
        FormsModule,
        ReactiveFormsModule,
        CmpsInsightExplorerModule,
        CmpsMyCoachingCardModule,
        CmpsButtonModule,
        CmpsTooltipModule,
        CmpsPortalModule,
        CmpsQuickAccessModule,
    ],
    declarations: [MyPerformanceCardComponent, CmpsPillarViewDialogComponent],
    exports: [MyPerformanceCardComponent],
    providers: [MyPerformanceCardService],
})
export class CmpsMyPerformanceCardModule {
    constructor() {
        myPerformanceCardEpics.forEach((e) => epicObs.next(e));
        performanceCardEpics.forEach((e) => epicObs.next(e));
        metricPerformanceDataEpics.forEach((e) => epicObs.next(e));
    }
}
